import { combineReducers } from 'redux';
import app from './app';
import i18n from './i18n';
import auth from './auth';
import cities from './cities';
import dwellings from './dwellings';
import dwelling from './dwelling';
import subscriptions from './subscriptions';
import boligagents from './boligagents';
import search from './search';

const reducer = combineReducers({
  app,
  i18n,
  auth,
  cities,
  dwellings,
  dwelling,
  search,
  subscriptions,
  boligagents
});

export default reducer;
